module.exports = __webpack_public_path__ + "img/login-coccia.d868f061.png";